import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getVertexAI, getGenerativeModel } from "firebase/vertexai-preview";

const firebaseConfig = {
  apiKey: "AIzaSyCYcUFmfwOMbkoyWrL-qGV0UqTqx7YeliI",
  authDomain: "pdf-translator-ea570.firebaseapp.com",
  projectId: "pdf-translator-ea570",
  storageBucket: "pdf-translator-ea570.firebasestorage.app",
  messagingSenderId: "788258082099",
  appId: "1:788258082099:web:a9d18fb143650e72164246",
  measurementId: "G-LL33TK7CW4",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const vertexAI = getVertexAI(app);
const model = getGenerativeModel(vertexAI, {
  model: "gemini-1.5-pro-001",
});

export { app, vertexAI, model, analytics };
